import React from "react";
import { Search, X } from "lucide-react";

/**
 * La barra dei filtri, uguale su tutte le pagine che portano un elenco lungo.
 *
 * È quella dei documenti dei sistemi di gestione: le tendine a sinistra, la
 * ricerca accanto, il conteggio a destra. Sta in un componente solo perché in
 * quattro pagine diverse deve comportarsi allo stesso modo — stessa posizione,
 * stesse parole, stesso modo di azzerare — altrimenti chi la impara in un posto
 * la ritrova diversa nell'altro.
 *
 * `filtri` è un elenco di tendine: { valore, onChange, tutti, opzioni }.
 * `opzioni` sono stringhe, oppure { valore, nome } quando quello che si mostra
 * non è quello che si salva.
 */
export default function BarraFiltri({
  filtri = [], cerca, onCerca, segnaposto = "Cerca...",
  conteggio, etichetta = "righe", azioni,
}) {
  const attivo = (cerca || "").trim() !== "" ||
    filtri.some((f) => f.valore !== "" && f.valore !== undefined && f.valore !== null);

  const azzera = () => {
    onCerca?.("");
    filtri.forEach((f) => f.onChange(""));
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="barra-filtri">
      {filtri.map((f, i) => (
        <select key={i} value={f.valore ?? ""} data-testid={f.testid || `filtro-${i}`}
                onChange={(e) => f.onChange(e.target.value)}
                className="h-10 border border-slate-200 rounded-lg px-3 text-sm
                           bg-white text-slate-700 min-w-[140px]">
          <option value="">{f.tutti}</option>
          {(f.opzioni || []).map((o) => {
            const valore = typeof o === "string" ? o : o.valore;
            const nome = typeof o === "string" ? o : o.nome;
            return <option key={valore} value={valore}>{nome}</option>;
          })}
        </select>
      ))}

      {onCerca && (
        <div className="relative flex-1 min-w-[180px] max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input value={cerca || ""} onChange={(e) => onCerca(e.target.value)}
                 placeholder={segnaposto} data-testid="barra-cerca"
                 className="w-full h-10 border border-slate-200 rounded-lg pl-9 pr-3
                            text-sm placeholder:text-slate-400" />
        </div>
      )}

      {attivo && (
        <button type="button" onClick={azzera} data-testid="barra-azzera"
                className="text-xs text-orange-600 hover:underline flex items-center gap-1">
          <X className="w-3 h-3" /> azzera
        </button>
      )}

      {conteggio !== undefined && (
        <span className="text-xs text-slate-400 ml-auto whitespace-nowrap">
          {conteggio} {etichetta}
        </span>
      )}
      {azioni}
    </div>
  );
}
